export const setShop = (all) => ({
  type: 'SET_SHOP',
  all: all
})



// WEBPACK FOOTER //
// ./src/actions/shop.js